import { ajax } from "@/plugins/ajax";

export default {
  namespaced: true,
  state: {
    list: []
  },
  getters: {
    list: state => state.list
  },
  actions: {
    fetch({ commit, dispatch }) {
      return ajax.get("Credits/api/GroupAccountsQuery").then(r => {
        commit("setList", r.data.data);
        return r.data.data;
      });
    },
    create({ commit, dispatch }, model) {
      return ajax.post("Credits/api/GroupAccounts", model).then(() => {
        dispatch("fetch");
      });
    },
    remove({ commit, dispatch }, id) {
      return ajax
        .delete(
          "Credits/api/GroupAccounts",
          { data: { id: id } },
          { headers: { "Content-Type": "application/json" } }
        )
        .then(() => {
          dispatch("fetch");
        });
    },
    update({ commit, dispatch }, model) {
      return ajax.put("Credits/api/GroupAccounts", model).then(() => {
        dispatch("fetch");
      });
    }
  },
  mutations: {
    setList(state, data) {
      state.list = data;
    }
  }
};
